import store from "@/store";

function stationIdInList(stationId, list) {
	return (list || []).some((s) => String(s) === String(stationId));
}

export class ProductOrderService {
	constructor() {}

	/**
	 * Indica si el ítem de pedido se trata como "ghost" (fuera del foco de estaciones) para la cocina.
	 * - Modo include (por defecto): ghost si no comparte ninguna estación con selectedStations; sin
	 *   elaborationStations o sin ids → ghost cuando hay filtro (no encaja con la whitelist).
	 * - Modo exclude: ghost solo si el producto intersecta selectedStations (lista de excluidas).
	 *   Sin elaborationStations o sin ids → no ghost (siguen visibles: no se excluyen por estación).
	 *   Producto con varias estaciones: basta una intersección con la lista de excluidas para marcarlo ghost.
	 */
	checkIsGhostProductOrder(productOrder) {
		if (store.getters["copilot/showAllProductOrdersInKitchen"]) return false;

		const selectedStations = store.getters["copilot/selectedStations"] || [];
		const mode = store.getters["copilot/elaborationStationFilterMode"];

		const stations = productOrder?.elaborationStations;
		const hasStationList = Array.isArray(stations) && stations.length > 0;
		const productElaborationStationIds = hasStationList
			? stations.map((es) => es?.id).filter((id) => id != null)
			: [];
		const hasStationIds = productElaborationStationIds.length > 0;

		if (mode === "exclude") {
			if (selectedStations.length === 0) return false;
			if (!hasStationIds) return false;
			return productElaborationStationIds.some((id) => stationIdInList(id, selectedStations));
		}

		if (!hasStationIds) return true;
		const hasCommonStations = productElaborationStationIds.some((id) => stationIdInList(id, selectedStations));
		return !hasCommonStations;
	}
}

export const productOrderService = new ProductOrderService();
